export default __webpack_public_path__ + "static/działki-f9887ff381b417b0d3c94aa67af26fd0.webp";